import React, { Suspense, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import ErrorBoundary from '../ErrorBoundary';
import { PageLoader } from '../ui/States';

/**
 * Persistent portal shell: sidebar + header stay mounted while pages change,
 * so navigation state, scroll position and the header's data survive routing.
 */
const AppLayout = () => {
  const { pathname } = useLocation();
  const mainRef = useRef(null);
  const firstRender = useRef(true);

  // Reset scroll and move focus to the content region on navigation (screen readers
  // then start at the new page instead of the old link).
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    mainRef.current?.focus({ preventScroll: true });
  }, [pathname]);

  return (
    <div className="app-shell">
      <a href="#main-content" className="skip-link visually-hidden-focusable">Skip to content</a>
      <Sidebar />
      <div className="app-main">
        <Header />
        <main id="main-content" className="app-content" ref={mainRef} tabIndex={-1} style={{ outline: 'none' }}>
          <ErrorBoundary resetKey={pathname}>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AppLayout;
